import { Clipboard, ModelRow } from "@mcleod/core";
import { AutogenLayoutTableTriumphPayAuditDocument } from "./autogen/AutogenLayoutTableTriumphPayAuditDocument";
import { ClickEvent, Snackbar } from "@mcleod/components";

export class TableTriumphPayAuditDocument extends AutogenLayoutTableTriumphPayAuditDocument {

    protected buttonCopyUrlOnClick(event: ClickEvent) {
        this.copyUrlToClipboard(event.target["row"]?.data);
    }

    protected copyUrlOnClick(event: ClickEvent) {
        this.copyUrlToClipboard(event.target["sourceComponent"]?.data);
    }

    private copyUrlToClipboard(data: ModelRow): void {
        const fullText = data?.getString("transfer_exception", "");
        if (!fullText) {
            Snackbar.showWarningSnackbar("No data available for copying");
            return;
        }

        // Find the PDF URL using regex
        const pdfMatch = fullText.match(/Pdf\s*=\s*(https:\/\/[^\s]+)/i);

        if (pdfMatch && pdfMatch[1]) {
            const pdfUrl = pdfMatch[1];
            Clipboard.copyText(pdfUrl).then(
                () => Snackbar.showSuccessSnackbar("PDF URL copied to clipboard"));
        } else {
            Snackbar.showWarningSnackbar("No PDF URL found");
        }
    }
}
